import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Subscription } from "rxjs/Subscription";
import { MatDialog, MatDialogRef } from "@angular/material";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { ResultDialogComponent } from "../result-dialog/result-dialog.component";
import { AuthGuardService, UserService, LoadingService } from "@core/services";
import { Headers, Http, RequestOptions } from "@angular/http";

@Component({
  selector: "app-refund-dialog",
  templateUrl: "./refund-dialog.component.html",
  styleUrls: ["./refund-dialog.component.css"],
})
export class RefundDialogComponent implements OnInit, OnDestroy {
  public paymentId: string;
  public amount: number;
  public testAmount: number;
  private capAmount: number;
  public user: any;
  private subscription: Subscription;
  public startDate: any;
  public endDate: any;
  public isLoadingPaymentHistory: boolean;
  public isLoadingCreditHistory: boolean;
  public isMobileUser: boolean;
  public sentRequest: boolean = false;
  public paymentHistory: any;
  private paymentCount: number;

  constructor(
    public dialogRef: MatDialogRef<RefundDialogComponent>,
    private _authGuard: AuthGuardService,
    private _http: Http,
    private _router: Router,
    private _service: UserService,
    private _fb: FormBuilder,
    private dialog: MatDialog,
    private _loadingService: LoadingService
  ) {}

  ngOnInit() {
    this.subscription = this._service.getUser().subscribe((user) => {
      this.user = user;
      console.log(this.user);
      this.isMobileUser = this.user.customerIdArray[
        this.user.customerIndex
      ].WebUser.Email.toLowerCase().includes("_mobl");
      console.log(this.isMobileUser);
    });
    this.capAmount = this.amount;
    this.testAmount = parseInt((this.amount * 100).toString());
    console.log(this.amount * 10)
    console.log('Modulo: ' + (this.amount * 100 % 465))
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  refundPayment() {
    //Prevent any refund that is greater than payment amount.
    if (
      this.amount > this.capAmount ||
      this.amount == 0 ||
      this.amount < 0 ||
      this.amount == null ||
      this.amount == undefined ||
      this.sentRequest
    )
      return;
    //this._loadingService.showLoader();
    this.sentRequest = true;
    console.log("Made it to refund payment!");
    const url = `CustomerService/VoidRefundPayment`;
    //alter data sent if mobile refund
    let data = {};
    if (this.isMobileUser) {
      data = {
        PaymentId: this.paymentId,
        Amount: this.amount.toFixed(2),
        MobileUser: true,
        AccountId: this.user.customerIdArray[this.user.customerIndex].Account
          .Id,
      };
    } else {
      data = {
        PaymentId: this.paymentId,
        Amount: this.amount.toFixed(2),
      };
    }

    this._authGuard.authenticatedPost(url, data).subscribe(
      (result) => {
        this.dialogRef.close();
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            title: "Success",
            message: `Your refund request for the amount ${this.amount.toFixed(
              2
            )} was successful.`,
            alertType: "success",
          },
          width: "350px",
        });
        this.getHistory();
        dialogRef.afterClosed().subscribe((result) => {
          this._router.navigate(["account"]);
        });
        //this._loadingService.hideLoader();
      },
      (error) => {
        this.dialogRef.close();
        if (error.includes("Txn not settled")) {
          error =
            "Transaction has not cleared yet, please try to refund again tomorrow.";
        }
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            title: "Error",
            message:
              error ==
              "Transaction has not cleared yet, please try to refund again tomorrow."
                ? "Transaction has not cleared yet, please try to refund again tomorrow."
                : `Error occured: ${error}`,
            alertType: "danger",
          },
          width: "350px",
        });
        //this._loadingService.hideLoader();
      }
    );
  }

  getHistory() {
    this.paymentCount = 0;
    this.getPaymentHistory();
    this.getCreditHistory();
  }

  getCreditHistory() {
    const creditHistoryUrl = "portfolios/CreditPaymentHistory";
    let creditResult: any;
    let data = this.setUpPaymentHistoryData();

    this._authGuard.authenticatedPost(creditHistoryUrl, data).subscribe(
      (result) => {
        this._service.emptyCreditHistoryArray();
        this.isLoadingCreditHistory = false;
        creditResult = result;
        for (const credit of creditResult) {
          if (credit.cardnumber != "Account Payment") {
            this._service.addCredit(
              credit.id,
              credit.paymentdate,
              credit.amountpaid,
              credit.cardnumber
            );
          }
        }
      },
      (error) => console.log("Error: " + error)
    );
  }

  setUpPaymentHistoryData() {
    let accountId = ""
    if(this.user.accountSummaryArray.length > 0){
      accountId = this.user.accountSummaryArray[this.user.accountIndex].id
    } else {
      accountId = this.user.customerIdArray[this.user.customerIndex].Account.Id
    }
    return {
      CustomerId: this.user.customerIdArray[this.user.customerIndex].Id,
      AccountId: accountId,
      StartDate: this.startDate,
      EndDate: this.endDate,
    };
  }

  getPaymentHistory() {
    const creditHistoryUrl = "portfolios/PaymentHistory";
    let paymentResult: any;
    let data = this.setUpPaymentHistoryData();

    this._authGuard.authenticatedPost(creditHistoryUrl, data).subscribe(
      (result) => {
        this._service.emptyPaymentHistoryArray();
        this.isLoadingPaymentHistory = false;
        console.log(result);
        paymentResult = result;
        this.paymentHistory = this.buildPaymentHistory(paymentResult);
        this.paymentHistory = paymentResult;
        for (let payment of paymentResult) {
          if (payment.currency) {
            payment.currency = payment.currency == 1 ? "CAD" : "USD";
            console.log(payment.currency);
          }

          this._service.addPayment(
            payment.id,
            payment.cardnumber,
            payment.paymentdate,
            payment.amountpaid,
            payment.authcode
          );
          this.paymentCount += 1;
        }
      },
      (error) => console.log("Error: " + error)
    );
  }

  private buildPaymentHistory(data) {
    return data.map((e) => {
      e.reference = e.authcode.split("|")[1];
      e.auth = e.authcode.split("|")[0];
      e.status = this.extractStatus(e.authcode);
      return e;
    });
  }

  private extractStatus(authcode) {
    let code = authcode.toLowerCase();
    if (code.includes("declined")) {
      return "Declined";
    } else if (code.includes("voided")) {
      return "Voided";
    } else if (code.includes("partially")) {
      var tempSplit = authcode.split("|");
      var tempStr = "";
      tempSplit.forEach((element) => {
        if (element.toString().includes("Partially")) {
          tempStr = element.toString();
          return element.toString();
        }
      });
      return tempStr;
    } else if (code.includes("refunded")) {
      return "Refunded";
    } else if (code.includes("approved")) {
      return "Approved";
    } else {
      return "N/A";
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/refund-dialog/refund-dialog.component.ts